import React from 'react';
import PollView from '../../../PollView';
// TODO: merge PollView into this
export var PollFullView = function (_a) {
    var deviation = _a.deviation;
    return React.createElement(PollView, { deviation: deviation });
};
PollFullView.displayName = 'PollFullView';
export default PollFullView;
//# sourceMappingURL=Poll.js.map